import Unit from './Unit'
import { UnitTypes, BrochureFileNameLocaleKeys } from '@/constants/units'
import ProjectType from '@/classes/ProjectType'
export default class HouseUnit extends Unit {
  get brochureFileNameLocaleKey() {
    const projectType = new ProjectType()
    return projectType.switcher({
      [projectType.SINGLETOWER_TYPE]:
        BrochureFileNameLocaleKeys.SINGLETOWER_HOUSE,
      [projectType.MULTITOWER_TYPE]:
        BrochureFileNameLocaleKeys.MULTITOWER_HOUSE,
      [projectType.NEIGHBOURHOOD_TYPE]:
        BrochureFileNameLocaleKeys.NEIGHBOURHOOD_HOUSE,
    })
  }
  get type() {
    return UnitTypes.HOUSE
  }
}
